<template>
  <v-layout row wrap>
    <Loader v-if="loading" skin="light"></Loader>
    <v-flex v-else xs12 class="pa-3">
      <v-dialog
        v-model="dialog"
        persistent
        max-width="590px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title primary-title>
            <span v-if="!editMode">Přidat uživatele</span><span v-else>Upravit uživatele {{ dItem.nazev }}</span>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-text-field
                  label="E-mail"
                  v-model="dEmail"
                  :disabled="editMode"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  label="Jméno"
                  v-model="dFirstname"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 md6>
                <v-text-field
                  label="Příjmení"
                  v-model="dLastName"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-select
              :items="privileges"
              label="Role"
              hide-details
              color="indigo darken-4"
              item-text="nazev"
              item-value="id"
              v-model="dPrivilege"
            ></v-select>
            <v-btn color="blue accent-3" flat class="ml0 mt-4" v-if="editMode && !dChangePassword" @click="dChangePassword=true">Změnit heslo</v-btn>
            <v-text-field
              v-if="!editMode || dChangePassword"
              :append-icon="dPasswordShow ? 'visibility_off' : 'visibility'"
              :type="dPasswordShow ? 'text' : 'password'"
              label="Heslo"
              v-model="dPassword"
              @click:append="dPasswordShow = !dPasswordShow"
              class="mt-5"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn v-if="!editMode" color="green" flat @click="add" :loading="sending">Vyvořit uživatele</v-btn>
            <v-btn v-else color="green" flat @click="edit" :loading="sending">Upravit uživatele</v-btn>
            <v-btn color="grey" flat @click="dialog=false;" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="dialogRemove"
        persistent
        max-width="500px"
        transition="dialog-transition"
        v-if="dItem != null"
      >
        <v-card>
          <v-card-text>
            <p class="text-center title mt-4">Opravdu chcete smazat uživatele <strong>{{ dItem.cele_jmeno }}</strong>?</p>
            <p class="subheading red--text text--darken-3 text-center mt-4">Napište text: <strong>{{ dRemoveRandomString }}</strong></p>
            <v-text-field
              label="Pro smazání opište výše uvedený text"
              v-model="dRemoveRandomStringCheck"
              class="mt-5"
            ></v-text-field>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" flat @click="remove" :loading="sending" v-if="dRemoveRandomStringCheck==dRemoveRandomString">Smazat uživatele</v-btn>
            <v-btn color="grey" flat @click="dialogRemove=false;" v-if="!sending">Zavřít</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-btn color="blue accent-3" class="mt-2 ml0" flat @click="addClick"><v-icon>add</v-icon> Přidat uživatele</v-btn>
      <v-data-table
        :headers="headers"
        :items="users"
        hide-controls
        class="elevation-0 mt-3"
      >
        <template slot="items" slot-scope="props">
          <tr>
            <td>{{props.item.cele_jmeno}}</td>
            <td>{{props.item.email}}</td>
            <td>{{props.item.role.nazev}}</td>
            <td class="text-xs-right">
              <v-tooltip bottom>
                <v-btn slot="activator" color="blue" flat fab class="ma-0 mt-5 mb-5 mr-2" @click="editClick(props.item)" small><v-icon small>edit</v-icon></v-btn>
                <span>Upravit uživatele</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn slot="activator" color="red darken-2" flat fab class="ma-0 mt-5 mb-5" @click="removeClick(props.item)" small><v-icon small>delete_forever</v-icon></v-btn>
                <span>Smazat uživatele</span>
              </v-tooltip>
            </td>
          </tr>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  data () {
    return {
      loading: true,
      headers: [
        { text: "Jméno a příjmení", value: "cele_jmeno" },
        { text: "E-mail", value: "email" },
        { text: "", value: null, sortable: false }
      ],
      users: [],
      privileges: [],
      dialog: false,
      editMode: false,
      dFirstname: "",
      dLastName: "",
      dEmail: "",
      dPasswordShow: false,
      dPassword: "",
      dChangePassword: false,
      dPrivilege: null,
      sending: false,
      dItem: null,
      dRemoveRandomString: "",
      dRemoveRandomStringCheck: "",
      dialogRemove: false
    }
  },
  props: {
    tab: String
  },
  mounted: function() {
    //this.load();
  },
  methods: {
    load: function() {
      window.api.get("uzivatele").then(function($r) {
        this.users = $r.uzivatele;
        this.privileges = $r.role;
        this.loading = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    addClick: function() {
      this.editMode = false;
      this.dFirstname = "";
      this.dLastName = "";
      this.dEmail = "";
      this.dPasswordShow = false;
      this.dPassword = "";
      this.dChangePassword = false;
      this.dPrivilege = null;
      this.dialog = true;
    },
    add: function() {
      this.sending = true;
      window.api.post("uzivatele", {
        email: this.dEmail,
        jmeno: this.dFirstname,
        prijmeni: this.dLastName,
        heslo: this.dPassword,
        role: this.dPrivilege
      }).then(function($r) {
        this.sending = false;
        if ($r.status) {
          this.users.push($r.data);
          this.dialog = false;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    editClick: function($user) {
      this.editMode = true;
      this.dItem = $user;
      this.dFirstname = $user.jmeno;
      this.dLastName = $user.prijmeni;
      this.dEmail = $user.email;
      this.dPasswordShow = false;
      this.dPassword = "";
      this.dChangePassword = false;
      this.dPrivilege = $user.role.id;
      this.dialog = true;
    },
    edit: function() {
      this.sending = true;
      window.api.put("uzivatele/"+this.dItem.id, {
        email: this.dEmail,
        jmeno: this.dFirstname,
        prijmeni: this.dLastName,
        heslo: this.dPassword,
        role: this.dPrivilege
      }).then(function($r) {
        this.sending = false;
        if ($r.status) {
          this.dItem.email = this.dEmail;
          this.dItem.jmeno = this.dFirstname;
          this.dItem.prijmeni = this.dLastName;
          this.dItem.cele_jmeno = this.dFirstname + " " + this.dLastName;
          this.dItem.role = $r.data.role;
          this.dialog = false;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    removeClick: function($user) {
      this.dItem = $user;
      window.api.get("uzivatele/smazat/"+this.dItem.id).then(function($r) {
        this.dRemoveRandomString = $r.random;
        this.dRemoveRandomStringCheck = "";
        this.dialogRemove = true;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    },
    remove: function() {
      this.sending = true;
      window.api.delete("uzivatele/"+this.dItem.id).then(function($r) {
        this.sending = false;
        if ($r.status) {
            this.load();
            this.dialogRemove = false;
        }
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
  components: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Nastaveni/Uzivatele.vue